/* eslint-disable react-hooks/exhaustive-deps */
/**
 *
 * Individiual
 *
 */
import React, { memo, useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { media } from 'styles/media';
import { useAdvisor } from 'app/Provider/AdvisorProvider';
import { ProfessionalAdvisoryDetails } from '../AdvisorDetails';
import { BankDetailsForm } from '../BankDetailsForm';
import { KycDocumentUpload } from '../KycDocumentUpload';
import { LogoUploadForm } from '../LogoUploadForm';

import { useDispatch, useSelector } from 'react-redux';
import { selectUpdateAdvisor } from './slice/selectors';
import co from './assests/co.svg';
import info from 'app/components/SequentialSteps/assests/ci_info.svg';
import completed from 'app/components/SequentialSteps/assests/money.svg';
import { CircleChevronRight, CircleCheck } from 'lucide-react';
import { useUpdateAdvisorSlice } from './slice';
import { useAuth } from 'app/Provider/AuthProvider';
import { Toast } from '../Toast';

interface Props {}

export const SequentialSteps = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const formRef = useRef<any>();
  const dispatch = useDispatch();
  const { actions } = useUpdateAdvisorSlice();
  const { failureResponse } = useSelector(selectUpdateAdvisor);
  const socialBaseURL = `${process.env.REACT_APP_CDN_URL}/socials`;
  const [, setStoredFormData] = useState<FormData | null>(null);
  const [, setStoredFormData2] = useState<FormData | null>(null);
  const [, setShowLoader] = useState(false);
  const { getProfile } = useAuth();

  // Advisor Provider
  const {
    advisorData,
    stepFour,
    stepOne,
    stepThree,
    stepTwo,
    nextStep,
    setCompanyName,
    setOfficeAddress,
    setassestsundermanagement,
    setYearsOfExperience,
    trackSubmission,
    setTrackSubmission,
    setFreeConsultancy,
    setAumFee,
    setHourlyCheckBox,
    setFlatFeeCheckBox,
    setHourlyrate,
    setFlatfee,
    setFeePercentage,
    setMinimumfee,
    setSpecializationAreas,
    setSebiriaNumber,
    setRegistrationType,
    setProfileField,
  } = useAdvisor();

  const Step1 = values => {
    setassestsundermanagement(values.assests_under_management);
    setSpecializationAreas(values.specialization_areas);
    setCompanyName(values.company_name);
    setOfficeAddress(values.office_address);
    setYearsOfExperience(values.years_of_experience);
    setSebiriaNumber(values.sebi_ria_number);
    setRegistrationType(values.registration_type);
    setProfileField('first_name', values.first_name);
    setProfileField('last_name', values.last_name);
    nextStep();
    if (trackSubmission.professionalDetails) {
      nextStep();
      if (trackSubmission.imageUpload) {
        nextStep();
      }
    }
  };
  const formatCharges = values => {
    const charges: any = {};

    if (values.charge_free) {
      charges.free_consultation = true;
    }

    if (values.charge_aum) {
      charges.aum_based = {
        fee_percentage: Number(values.fee_percentage),
        minimum_fee: values.minimum_fee ? Number(values.minimum_fee) : 0,
      };
    }

    if (values.hourly_box) {
      charges.hourly_rate = {
        rate: Number(values.hourly_rate),
      };
    }

    if (values.flat_fee_box) {
      charges.flat_fee = {
        amount: Number(values.flat_fee),
      };
    }

    return charges;
  };
  const [charges, setCharges] = useState();

  const Step2 = values => {
    setCharges(formatCharges(values));
    // Conditionally update each state setter based on existence
    if (values.charge_free !== undefined) {
      setFreeConsultancy(values.charge_free);
    }

    if (values.charge_aum !== undefined) {
      setAumFee(values.charge_aum);
    }

    if (values.hourly_box !== undefined) {
      setHourlyCheckBox(values.hourly_box);
    }

    if (values.flat_fee_box !== undefined) {
      setFlatFeeCheckBox(values.flat_fee_box);
    }

    if (values.hourly_rate !== undefined) {
      setHourlyrate(Number(values.hourly_rate));
    }

    if (values.flat_fee !== undefined) {
      setFlatfee(Number(values.flat_fee));
    }

    if (values.fee_percentage !== undefined) {
      setFeePercentage(Number(values.fee_percentage));
    }

    if (values.minimum_fee !== undefined) {
      setMinimumfee(Number(values.minimum_fee));
    }
    nextStep();
    if (trackSubmission.imageUpload) {
      nextStep();
    }
  };

  const Step4 = values => {
    const advisorOnboardData = {
      file: {
        proof_of_address: {
          image: advisorData.individualdata.proofFile,
          type: 'address_proof',
        },
        pan: {
          image: advisorData.individualdata.panFile,
          type: 'pan',
        },
        brand: {
          image: advisorData.individualdata.imageFile,
          type: 'brand',
        },
      },
      payload: {
        data: {
          legal_business_name: advisorData.individualdata.company_name,
          corporate_address: advisorData.individualdata.office_address,
          first_name: advisorData.profile.first_name,
          last_name: advisorData.profile.last_name,
          registration_type: advisorData.registrationType,
          sebiria_number: advisorData.individualdata.sebiria_number,
          years_of_experience: Number(
            advisorData.individualdata.years_of_experience,
          ),
          gst_number: advisorData.individualdata.gst_number,
          specialization_areas: advisorData.individualdata.specialization_areas,
          assets_under_management:
            advisorData.individualdata.assest_under_management,
          proof_of_address: advisorData.individualdata.proof_type,
        },
        charges: charges,
      },
    };

    dispatch(actions.updateAdvisor(advisorOnboardData));
    setStoredFormData2(values);
  };
  useEffect(() => {
    if (failureResponse) {
      Toast.error(failureResponse.message);
      dispatch(actions.createAdvisorReset());
    }
  }, [failureResponse]);

  const Step3 = values => {
    setStoredFormData(values);
    nextStep();
    // dispatch(uploadActions.advisorUploadCreate(values));
  };

  useEffect(() => {
    return () => {
      setShowLoader(false);
    };
  }, []);

  const renderPageContent = () => {
    switch (advisorData.activeStep) {
      case 1:
        return <ProfessionalAdvisoryDetails ref={formRef} onsubmit={Step1} />;
      case 2:
        return <BankDetailsForm ref={formRef} onsubmit={Step2} />;
      case 3:
        return <LogoUploadForm ref={formRef} onsubmit={Step3} />;

      case 4:
        return <KycDocumentUpload ref={formRef} onSubmit={Step4} />;
    }
  };
  const handleLetsGo = () => {
    getProfile();
  };

  return (
    <Div className="d-flex flex-column">
      {t('')}
      {/*  {t(...messages.someThing())}  */}
      <div style={{ background: ' #FFFFFF' }}>
        <LogoWrapper className="d-flex align-items-center justify-content-center  justify-content-xl-start">
          <img
            style={{ width: '150px', height: '25px' }}
            src={`${socialBaseURL}/logo.svg`}
            alt="logo"
          />
        </LogoWrapper>
      </div>
      <div
        className="d-flex h-100"
        style={{
          gap: '20px',
          paddingLeft: '20px',
          paddingRight: '20px',
          marginBottom: '20px',
          overflowY: 'auto',
        }}
      >
        <FirstChild>
          <div style={{ borderBottom: '1px solid #E4E6EC' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                paddingLeft: '20px',
                paddingRight: '20px',
                fontSize: '16px',
                fontWeight: '600',
              }}
            >
              Getting Started
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: '30px',
                  height: '30px',
                  background: ' #F3F1FE',
                  borderRadius: '10px',
                }}
              >
                <img
                  src={completed}
                  alt="user"
                  style={{ width: '16px', height: '16px' }}
                />
              </div>
            </div>
          </div>
          <SidebarButton
            className="align-items-center"
            isSelected={advisorData.activeStep === 1}
            onClick={() => {
              stepOne();
            }}
          >
            <div className="d-flex justify-content-between w-100 align-items-center">
              <Text>Personal & Professional Details</Text>
              <div className="d-flex justify-content-between align-items-center gap-2">
                <img
                  className="d-flex align-items-center justify-content-center"
                  src={info}
                  alt="info"
                  style={{ width: '19px', height: '19px' }}
                />
                <div>
                  {trackSubmission.personalDetails ? (
                    <CircleCheck
                      strokeWidth={1.25}
                      size={22}
                      color="#FFFF"
                      fill={'#8276F4'}
                    />
                  ) : (
                    <CircleChevronRight
                      strokeWidth={1.25}
                      size={19}
                      color="#8276F4"
                    />
                  )}
                </div>
              </div>
            </div>
          </SidebarButton>
          <SidebarButton
            className="align-items-center"
            isSelected={advisorData.activeStep === 2}
            onClick={() => {
              stepTwo();
            }}
          >
            <div className="d-flex justify-content-between w-100 align-items-center">
              <Text>Your subscription plans</Text>
              <div className="d-flex justify-content-between align-items-center gap-2">
                <img
                  className="d-flex align-items-center justify-content-center"
                  src={info}
                  alt="info"
                  style={{ width: '19px', height: '19px' }}
                />
                <div>
                  {trackSubmission.professionalDetails ? (
                    <CircleCheck
                      strokeWidth={1.25}
                      size={22}
                      color="#FFFF"
                      fill={'#8276F4'}
                    />
                  ) : (
                    <CircleChevronRight
                      strokeWidth={1.25}
                      size={19}
                      color="#8276F4"
                    />
                  )}
                </div>
              </div>
            </div>
          </SidebarButton>
          <SidebarButton
            className="align-items-center"
            isSelected={advisorData.activeStep === 3}
            onClick={() => {
              setTrackSubmission('imageUpload', false);
              stepThree();
            }}
          >
            <div className="d-flex justify-content-between w-100 align-items-center">
              <Text>Your brand details (optional)</Text>
              <div className="d-flex justify-content-between align-items-center gap-2">
                <img
                  className="d-flex align-items-center justify-content-center"
                  src={info}
                  alt="info"
                  style={{ width: '19px', height: '19px' }}
                />

                <div>
                  {trackSubmission.imageUpload ? (
                    <CircleCheck
                      strokeWidth={1.25}
                      size={22}
                      color="#FFFF"
                      fill={'#8276F4'}
                    />
                  ) : (
                    <CircleChevronRight
                      strokeWidth={1.25}
                      size={19}
                      color="#8276F4"
                    />
                  )}
                </div>
              </div>
            </div>
          </SidebarButton>
          <SidebarButton
            className="align-items-center"
            isSelected={advisorData.activeStep === 4}
            onClick={() => {
              setTrackSubmission('documentUpload', false);
              stepFour();
            }}
          >
            <div className="d-flex justify-content-between w-100 align-items-center">
              <Text>KYC verification</Text>
              <div className="d-flex justify-content-between align-items-center gap-2">
                <img
                  className="d-flex align-items-center justify-content-center"
                  src={info}
                  alt="info"
                  style={{ width: '19px', height: '19px' }}
                />
                <div>
                  {trackSubmission.documentUpload ? (
                    <CircleCheck
                      strokeWidth={1.25}
                      size={22}
                      color="#FFFF"
                      fill={'#8276F4'}
                    />
                  ) : (
                    <CircleChevronRight
                      strokeWidth={1.25}
                      size={19}
                      color="#8276F4"
                    />
                  )}
                </div>
              </div>
            </div>
          </SidebarButton>
        </FirstChild>
        <SecondChild>
          <div style={{ borderBottom: '1px solid #E4E6EC' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                paddingLeft: '20px',
                paddingRight: '20px',
                fontSize: '16px',
                fontWeight: '600',
              }}
            >
              {advisorData.activeStep === 1
                ? 'Personal & Professional Details'
                : advisorData.activeStep === 2
                ? 'Your subscription plans'
                : advisorData.activeStep === 3
                ? ` Your brand details(optional)`
                : advisorData.activeStep === 4
                ? 'KYC verification'
                : 'You are good to go'}
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: '30px',
                  height: '30px',
                  background: ' #F3F1FE',
                  borderRadius: '10px',
                }}
              >
                <img
                  src={completed}
                  alt="user"
                  style={{ width: '16px', height: '16px' }}
                />
              </div>
            </div>
          </div>
          <Container>
            {advisorData.activeStep <= 4 ? (
              renderPageContent()
            ) : (
              <>
                <div className="d-flex flex-column w-100 justify-content-center align-items-center mt-5 position-relative">
                  <Image src={co} alt="logo" />
                  <div className="mt-5">
                    <Congrats className="text-center pb-2">
                      {' '}
                      Congrats!
                      <CongratsInfoText>
                        You are a part of lighthouz family now!{' '}
                      </CongratsInfoText>
                    </Congrats>
                  </div>
                  <div className="mt-3">
                    <Invite className="text-center">
                      Start inviting clients and advise them to help make better
                      financial decisions:{' '}
                    </Invite>
                  </div>
                  <div className="d-flex justify-content-end my-3 w-100">
                    <Button type="button" onClick={handleLetsGo}>
                      Let's go
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Container>
        </SecondChild>
      </div>
    </Div>
  );
});

const Text = styled.h6`
  font-weight: 500;
  font-size: 14px;
  color: #22283a;
  margin: 0;
  align-items: start;
`;
const CongratsInfoText = styled.span`
  font-weight: 200;
  font-size: 32px;
`;
const LogoWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 30px;
  ${media.small} {
    margin-top: 40px;
  }
`;

const Invite = styled.h6`
  font-size: 20px;
  font-weight: 400;
  ${media.medium} {
    font-size: 16px;
  }
  ${media.small} {
    font-size: 14px;
  }
`;
const Congrats = styled.h6`
  font-size: 32px;
  font-weight: 400;
  ${media.medium} {
    font-size: 24px;
  }
  ${media.xlarge} {
    font-weight: 700;
  }

  border-bottom: 1px solid #c8ccd8;
  margin: 0;
`;
const Image = styled.img`
  ${media.small} {
    width: 131px;
    height: 131px;
  }
  ${media.medium} {
    width: 125px;
    height: 125px;
  }
  ${media.xlarge} {
    width: 150px;
    height: 150px;
  }
`;
const SidebarButton = styled.button<{ isSelected: boolean }>`
  height: 80px;
  width: 100%;
  display: flex;
  border: none;
  border-bottom: 1px solid #e4e6ec;
  background: ${prop => (prop.isSelected ? '#e4dfff' : 'transparent')};
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #22283a;
  transition: background-color 0.3s ease, color 0.3s ease;
  &:hover {
    background-color: #e4dfff;
  }
`;
const Button = styled.button`
  height: 52px;
  background-color: #8276f4;
  padding: 15px 30px;
  border-radius: 30px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  &:hover {
    background-color: #5c54ad;
  }
`;
const Div = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  background-color: #f5f6fa;
  height: 100vh;
  background: solid black;
  // border: solid black;
  ${media.small} {
    height: auto;
    min-height: 100vh;
  }
`;
const FirstChild = styled.div`
  width: 25%;
  flex-shrink: 0;
  border: 1px solid #f5f6fa;
  background: #ffffff;
  height: 100%;
  border-radius: 20px;
  background: #ffffff;
  ${media.small} {
    display: none;
  }
`;
const SecondChild = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #f5f6fa;
  background: #ffffff;
  height: 100%;
  overflow-y: auto;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  ${media.small} {
    width: 100%;
    height: auto; // Adjust to content height
    overflow: visible;
  }
`;
const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
  ${media.large} {
    padding-left: 170px;
    padding-right: 170px;
  }
  ${media.xlarge} {
    padding-left: 170px;
    padding-right: 170px;
  }
  ${media.small} {
    height: auto; // Adjust to content height
    overflow: visible;
  }
`;
